import type { UserInterface } from '@store/user/interfaces/userInterfaces';

// Single selector for the entire user state
export const selectUser = (state: { user: UserInterface }) => state.user;

// Selector for user data
export const selectIsLoadingUser = (state: { user: UserInterface }) =>
  state.user.isLoadingUser;

// Selector for user fetch error
export const selectUserFetchError = (state: { user: UserInterface }) =>
  state.user.errors?.userFetch;
